import { axiosAjaxCall } from "./common.service";

export const InquiriesService = {
    getInquiries,
}


function  getInquiries(data) {    
    return axiosAjaxCall("get-inquiries", data);
}